import { render, staticRenderFns } from "./ShirtUploadImage.vue?vue&type=template&id=512324b2&scoped=true"
import script from "./ShirtUploadImage.vue?vue&type=script&lang=js"
export * from "./ShirtUploadImage.vue?vue&type=script&lang=js"
import style0 from "./ShirtUploadImage.vue?vue&type=style&index=0&id=512324b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512324b2",
  null
  
)

export default component.exports